module.exports = __webpack_public_path__ + "static/media/topSelect1.125bd021.svg";